import React, { Component } from "react";
import {
  Card,
  CardBody,
  Col,
  Row,
  Button,
  Modal,
  Container,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
  Badge,
  Spinner,
  Input,
} from "reactstrap";
import {
  listRoomBookingRequest,
  updatePaymentStatus,
} from "../../Endpoint/Admin/index";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { ToastContainer, toast } from "react-toastify";

class Booking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      isLoaded: false,
      // Pagination
      currentPage: 1,
      totalPages: 1,
      totalCount: 0,
      limit: 15,
      search: "",
      // Detail modal
      showDetailModal: false,
      selectedBooking: null,
      breadcrumbItems: [
        { title: "Dashboard", link: "/dashboard" },
        { title: "Room Bookings", link: "#" },
      ],
    };
  }

  componentDidMount() {
    this.getAllBookings();
  }

  getAllBookings = (page = this.state.currentPage, search = this.state.search) => {
    const { limit } = this.state;
    this.setState({ isLoaded: false });

    listRoomBookingRequest(page, limit, search)
      .then((result) => {
        const pagination = result?.pagination || {};
        this.setState({
          isLoaded: true,
          items: result?.data || [],
          currentPage: pagination.currentPage || 1,
          totalPages: pagination.totalPages || 1,
          totalCount: pagination.totalCount || 0,
        });
      })
      .catch((error) => {
        console.error(error);
        this.setState({ isLoaded: true, items: [] });
      });
  };

  // View booking detail
  viewBookingDetail = (booking) => {
    this.setState({
      showDetailModal: true,
      selectedBooking: booking,
    });
  };

  closeDetailModal = () => {
    this.setState({
      showDetailModal: false,
      selectedBooking: null,
    });
  };

  // Update payment status
  StatusChangeRequest = (roomBookingId, isPaymentSuccess) => {
    updatePaymentStatus(roomBookingId, isPaymentSuccess)
      .then((response) => {
        if (response.status === 200) {
          toast.success(response.message);
          this.getAllBookings();
          this.closeDetailModal();
        } else {
          toast.error(response.message);
        }
      })
      .catch(() => toast.error("Error updating payment status"));
  };

  // Get payment badge
  getPaymentBadge = (booking) => {
    if (booking.isPaymentSuccess) return <Badge color="success">Paid</Badge>;
    return <Badge color="warning">Pending</Badge>;
  };

  // Get payment method label
  getPaymentMethodLabel = (type) => {
    return type === 1 ? "Cash" : "Online";
  };

  render() {
    const { items, isLoaded, currentPage, totalPages, totalCount, limit, search, selectedBooking } = this.state;

    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs title="Room Bookings" breadcrumbItems={this.state.breadcrumbItems} />

            {/* Detail Modal */}
            <Modal
              isOpen={this.state.showDetailModal}
              toggle={this.closeDetailModal}
              size="lg"
              scrollable
            >
              <ModalHeader toggle={this.closeDetailModal} className="bg-primary text-white">
                <i className="ri-hotel-bed-line mr-2"></i> Booking Details
              </ModalHeader>
              <ModalBody className="p-0">
                {selectedBooking && (
                  <div>
                    {/* Status Header */}
                    <div className="p-3 bg-light border-bottom d-flex justify-content-between align-items-center">
                      <div>
                        <h5 className="mb-1">
                          {selectedBooking.bookingNumber || `#${selectedBooking._id?.slice(-6).toUpperCase()}`}
                        </h5>
                        <small className="text-muted">Booked on {selectedBooking.createdAt}</small>
                      </div>
                      <div>
                        {this.getPaymentBadge(selectedBooking)}
                      </div>
                    </div>

                    {/* Guest Info */}
                    <div className="p-3 border-bottom">
                      <h6 className="text-muted mb-2">
                        <i className="ri-user-line mr-1"></i> Guest Information
                      </h6>
                      <Row>
                        <Col md={6}>
                          <p className="mb-1"><strong>Name:</strong> {selectedBooking.guestName || selectedBooking.user || "N/A"}</p>
                          <p className="mb-0"><strong>Email:</strong> {selectedBooking.guestEmail || selectedBooking.email || "N/A"}</p>
                        </Col>
                        <Col md={6}>
                          <p className="mb-1"><strong>Phone:</strong> {selectedBooking.guestMobile || selectedBooking.mobile || "N/A"}</p>
                        </Col>
                      </Row>
                    </div>

                    {/* Room & Stay Info */}
                    <div className="p-3 border-bottom">
                      <h6 className="text-muted mb-2">
                        <i className="ri-home-4-line mr-1"></i> Room & Stay
                      </h6>
                      <Row>
                        <Col md={6}>
                          <p className="mb-1"><strong>Room:</strong> {selectedBooking.roomName || "N/A"}</p>
                          <p className="mb-0"><strong>Room Type:</strong> {selectedBooking.roomType || "N/A"}</p>
                        </Col>
                        <Col md={6}>
                          <p className="mb-1"><strong>No. of Rooms:</strong> {selectedBooking.rooms || 1}</p>
                          <p className="mb-0"><strong>Nights:</strong> {selectedBooking.nights || "N/A"}</p>
                        </Col>
                      </Row>
                    </div>

                    {/* Dates */}
                    <div className="p-3 border-bottom bg-light">
                      <Row>
                        <Col md={6} className="text-center border-right">
                          <small className="text-muted d-block">CHECK-IN</small>
                          <strong className="text-primary">{selectedBooking.startDate}</strong>
                        </Col>
                        <Col md={6} className="text-center">
                          <small className="text-muted d-block">CHECK-OUT</small>
                          <strong className="text-danger">{selectedBooking.endDate}</strong>
                        </Col>
                      </Row>
                    </div>

                    {/* Special Requests */}
                    {selectedBooking.specialRequests && (
                      <div className="p-3 border-bottom">
                        <h6 className="text-muted mb-1">
                          <i className="ri-chat-3-line mr-1"></i> Special Requests
                        </h6>
                        <p className="mb-0 font-italic">"{selectedBooking.specialRequests}"</p>
                      </div>
                    )}

                    {/* Payment Summary */}
                    <div className="p-3 border-bottom">
                      <h6 className="text-muted mb-2">
                        <i className="ri-money-dollar-circle-line mr-1"></i> Payment
                      </h6>
                      <Row>
                        <Col>
                          <p className="mb-1">
                            <strong className="text-primary" style={{ fontSize: "1.2rem" }}>
                              Total: ${(selectedBooking.finalOrderAmount || selectedBooking.total || 0).toFixed(2)}
                            </strong>
                          </p>
                          {selectedBooking.couponCode && (
                            <p className="mb-1 text-success">
                              Coupon ({selectedBooking.couponCode}): -${(selectedBooking.couponDiscount || 0).toFixed(2)}
                            </p>
                          )}
                          <p className="mb-0">
                            Payment Method: {this.getPaymentMethodLabel(selectedBooking.paymentMethodType)}
                          </p>
                        </Col>
                      </Row>
                    </div>
                  </div>
                )}
              </ModalBody>
              <ModalFooter>
                {selectedBooking && !selectedBooking.isPaymentSuccess && selectedBooking.paymentMethodType === 1 && (
                  <Button
                    color="success"
                    size="sm"
                    onClick={() => this.StatusChangeRequest(selectedBooking._id, true)}
                  >
                    <i className="ri-check-line mr-1"></i> Mark as Paid
                  </Button>
                )}
                <Button color="secondary" size="sm" onClick={this.closeDetailModal}>
                  Close
                </Button>
              </ModalFooter>
            </Modal>

            {/* Main Content */}
            <Row>
              <Col xs={12}>
                <Card>
                  <CardBody>
                    {/* Header with Search */}
                    <Row className="mb-3 align-items-center">
                      <Col md={6}>
                        <div className="d-flex">
                          <Input
                            type="text"
                            placeholder="Search by guest name, email, phone..."
                            value={search}
                            onChange={(e) => this.setState({ search: e.target.value })}
                            onKeyPress={(e) => {
                              if (e.key === "Enter") this.getAllBookings(1, search);
                            }}
                            style={{ maxWidth: "300px" }}
                          />
                          <Button
                            color="primary"
                            className="ml-2"
                            onClick={() => this.getAllBookings(1, search)}
                          >
                            Search
                          </Button>
                          {search && (
                            <Button
                              color="light"
                              className="ml-2"
                              onClick={() => {
                                this.setState({ search: "" }, () => this.getAllBookings(1, ""));
                              }}
                            >
                              Clear
                            </Button>
                          )}
                        </div>
                      </Col>
                      <Col md={6} className="text-right">
                        <span className="text-muted">
                          {totalCount} bookings total
                        </span>
                      </Col>
                    </Row>

                    {/* Bookings Table */}
                    {!isLoaded ? (
                      <div className="text-center py-5">
                        <Spinner color="primary" />
                        <p className="mt-2 text-muted">Loading bookings...</p>
                      </div>
                    ) : items.length === 0 ? (
                      <div className="text-center py-5">
                        <i className="ri-calendar-line" style={{ fontSize: "3rem", color: "#ccc" }}></i>
                        <p className="mt-2 text-muted">No bookings found</p>
                      </div>
                    ) : (
                      <div className="table-responsive">
                        <Table hover className="mb-0" style={{ fontSize: "13px" }}>
                          <thead className="thead-light">
                            <tr>
                              <th style={{ width: "120px" }}>Booked On</th>
                              <th>Guest</th>
                              <th>Room</th>
                              <th style={{ width: "140px" }}>Check-in</th>
                              <th style={{ width: "140px" }}>Check-out</th>
                              <th style={{ width: "80px" }}>Amount</th>
                              <th style={{ width: "100px" }}>Payment</th>
                              <th style={{ width: "100px" }}>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {items.map((booking, index) => (
                              <tr
                                key={booking._id || index}
                                onClick={() => this.viewBookingDetail(booking)}
                                style={{ cursor: "pointer" }}
                                className="booking-row"
                              >
                                <td>
                                  <small>{booking.createdAt}</small>
                                </td>
                                <td>
                                  <div>{booking.guestName || booking.user || "N/A"}</div>
                                  <small className="text-muted">{booking.guestMobile || booking.mobile}</small>
                                </td>
                                <td>
                                  <div>{booking.roomName || "N/A"}</div>
                                  <small className="text-muted">{booking.roomType}</small>
                                </td>
                                <td>
                                  <Badge color="success" className="font-size-11">
                                    {booking.startDate}
                                  </Badge>
                                </td>
                                <td>
                                  <Badge color="danger" className="font-size-11">
                                    {booking.endDate}
                                  </Badge>
                                </td>
                                <td>
                                  <strong>${(booking.finalOrderAmount || booking.total || 0).toFixed(2)}</strong>
                                </td>
                                <td>
                                  {this.getPaymentBadge(booking)}
                                </td>
                                <td onClick={(e) => e.stopPropagation()}>
                                  {!booking.isPaymentSuccess && booking.paymentMethodType === 1 ? (
                                    <Button
                                      color="warning"
                                      size="sm"
                                      onClick={() => this.StatusChangeRequest(booking._id, true)}
                                    >
                                      Mark Paid
                                    </Button>
                                  ) : (
                                    <span className="text-success">
                                      <i className="ri-check-double-line"></i> Complete
                                    </span>
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    )}

                    {/* Pagination */}
                    {totalPages > 1 && (
                      <Row className="mt-3">
                        <Col md={6}>
                          <span className="text-muted">
                            Page {currentPage} of {totalPages}
                          </span>
                        </Col>
                        <Col md={6}>
                          <div className="d-flex justify-content-end align-items-center">
                            <Button
                              color="light"
                              size="sm"
                              disabled={currentPage <= 1}
                              onClick={() => this.getAllBookings(currentPage - 1)}
                              className="mr-1"
                            >
                              Prev
                            </Button>

                            {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                              let pageNum;
                              if (totalPages <= 5) {
                                pageNum = i + 1;
                              } else if (currentPage <= 3) {
                                pageNum = i + 1;
                              } else if (currentPage >= totalPages - 2) {
                                pageNum = totalPages - 4 + i;
                              } else {
                                pageNum = currentPage - 2 + i;
                              }
                              return (
                                <Button
                                  key={pageNum}
                                  color={currentPage === pageNum ? "primary" : "light"}
                                  size="sm"
                                  className="mr-1"
                                  onClick={() => this.getAllBookings(pageNum)}
                                >
                                  {pageNum}
                                </Button>
                              );
                            })}

                            <Button
                              color="light"
                              size="sm"
                              disabled={currentPage >= totalPages}
                              onClick={() => this.getAllBookings(currentPage + 1)}
                              className="mr-2"
                            >
                              Next
                            </Button>

                            <Input
                              type="select"
                              value={limit}
                              onChange={(e) => {
                                this.setState({ limit: parseInt(e.target.value) }, () => {
                                  this.getAllBookings(1);
                                });
                              }}
                              style={{ width: "70px" }}
                              bsSize="sm"
                            >
                              <option value={10}>10</option>
                              <option value={15}>15</option>
                              <option value={25}>25</option>
                              <option value={50}>50</option>
                            </Input>
                          </div>
                        </Col>
                      </Row>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
        <ToastContainer />

        <style jsx>{`
          .booking-row:hover {
            background-color: #f8f9fa !important;
          }
        `}</style>
      </React.Fragment>
    );
  }
}

export default Booking;
